import { ProductType, UserInfo } from '@infraloop/services'

/**
 * Whether the signed-in user is an admin. Mirrors the editor's `USER_TYPES.ADMIN` check:
 * admins carry the `admin` product in `owned_products`.
 * @param user The signed-in user's profile, if loaded.
 */
export const isAdminUser = (user?: UserInfo): boolean => user?.owned_products?.includes(ProductType.Admin) ?? false
